export const m2l0Solution = `use debug::PrintTrait;

fn main() {
    let is_morning = true;
    if is_morning {
        ('Good morning!').print();
    }
    // do not modify code on this line or above

    //TODO: Finish the rest of this line like the example! Or make it be false!
	let is_evening = true;

    // do not modify code on this line or below

    if is_evening {
        ('Good evening!').print();
    }
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
